import React from 'react';
import Modal from 'components/Modal';
import Heading from 'components/Heading';
import Button from 'components/Button';
import { ButtonsDiv } from 'components/ConfirmationModal/styles';
import { Container } from './styles';

interface ValidationWarningModalProps {
  open: boolean;
  warnings: string[];
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  title?: string;
}

const ValidationWarningModal: React.FC<ValidationWarningModalProps> = ({
  open,
  warnings,
  onConfirm,
  onCancel,
  confirmText = 'Prosseguir',
  cancelText = 'Revisar',
  title = 'Atenção aos Dados',
}) => {
  if (!open || !warnings || warnings.length === 0) return null;

  return (
    <Modal open={open} onClose={onCancel}>
      <Container>
        <Heading>{title}</Heading>
        <p>Identificamos inconsistências nos dados preenchidos:</p>
        <ul>
          {warnings.map((warning, idx) => (
            <li key={idx}>{warning}</li>
          ))}
        </ul>
        <p className="question">Deseja prosseguir mesmo assim?</p>
        <ButtonsDiv>
          <Button onClick={onCancel} buttonType="secondary">
            {cancelText}
          </Button>
          <Button onClick={onConfirm} buttonType="primary">
            {confirmText}
          </Button>
        </ButtonsDiv>
      </Container>
    </Modal>
  );
};

export default ValidationWarningModal;
